<template>
  <div>
    <div class="maintain" v-if="maintainStatus==true">
      <p class="mt-head">维护公告</p>
      <br>
      <p class="mt-content">对不起，系统正在维护中，给您造成的不便敬请谅解。</p>
      <br>
      <p class="mt-content">预计维护结束时间:</p>
      <p class="mt-content">{{ endtime }}</p>
    </div>
    <div v-else class="login" id="login">
      <div class="lg-con">
        <p class="lg-con-head">账号登录</p>
        <p class="lg-con-msg">
          <ep-alert :type="errorState.type" v-if="errorState.type!=''">{{ errorState.msg }}</ep-alert>
        </p>
        <div :class="['lg-input',{'active':focusState[0]}]">
          <label for="name">
            <img src="../../../static/img/admin.png" alt="">
          </label>
          <input type="text" name="" v-model="user.username" id="name" @blur="loseFocus(0)" @focus="getFocus(0)"
                 @keyup.down="changeFocus(1)" @keyup.enter="login" @keyup.up="changeFocus(2)" autocomplete="off"
                 placeholder="请输入手机号">
        </div>
        <div :class="['lg-input',{'active':focusState[1]}]">
          <label for="psd">
            <img src="../../../static/img/lock.png" alt="">
          </label>
          <input :type="isShowPassword ? 'text' : 'password'"
                 name="" v-model="user.password"
                 @blur="loseFocus(1)"
                 @focus="getFocus(1)"
                 id="psd"
                 @keyup.down="changeFocus(2)"
                 @keyup.enter="login"
                 @keyup.up="changeFocus(0)"
                 autocomplete="off"
                 placeholder="请输入密码">
          <img class="eye" v-if="isShowPassword" src="../../../static/img/eye-close.png" @click="showPassword">
          <img class="eye" v-else src="../../../static/img/eye.png" @click="showPassword">

        </div>
        <div class="lg-verify">
          <input type="text" name="" v-model="user.imgcode" @blur="loseFocus(2)" @focus="getFocus(2)"
                 @keyup.down="changeFocus(0)" @keyup.enter="login" @keyup.up="changeFocus(1)" autocomplete="off"
                 placeholder="验证码">
          <span class="lg-verify-img" @click="changeVerify">
			<img :src="verifyUrl" alt="获取失败,请稍后重试">
			</span>
          <!-- <span class="lg-verify-txt" @click="changeVerify">看不清楚？换一张</span> -->
        </div>
        <button type="" @click="login">登录</button>
        <p class="lg-forget">
          <span style="margin-right: 20px">
			<a target="_blank" href="https://biaoqi8.yuque.com/docs/share/409b86f8-f7f5-42e6-8622-e6324906b356">帮助手册</a>
			</span>

					<span style="margin-right: 20px">
			<router-link to="registry">注册新用户</router-link>
			</span>
          <span>
			<router-link to="forget">忘记密码？</router-link>
			</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Apis from '@/data/api.js'
import account from '../../data/ucenter/account.js'
import captcha from '../../data/ucenter/captcha.js'
import company from '../../data/basic/plan/company.js'
import {mapMutations, mapState} from 'vuex'

export default {
  data() {
    return {
      //是否显示密码
      isShowPassword: false,
      // 登录状态
      loginStatu: true,
      // 错误状态
      errorState: {
        type: '',
        msg: ''
      },
      // 焦点状态
      focusState: [false, false, false],
      // 验证吗地址
      verifyUrl: '/api/ucenter/captcha/get?width=120&height=40',
      // 登录信息
      user: {
        username: '',
        password: '',
        imgcode: '',
        client: true
      },
      //设备是否维护
      maintainStatus: false,
      //维护截止时间
      endtime: "2018-11-14 20:00:00"
    }
  },
  mounted() {
    this.changeFocus(0)
    this.changeVerify();
    Apis.getEnv().then((resp) => {
      this.maintainStatus = resp.maintainStatus;
      if (typeof resp.maintainStatus === "string") {
        this.maintainStatus = resp.maintainStatus === "true" ? true : false;
      }
      this.endtime = resp.endtime;
    });
  },
  methods: {
    ...mapMutations(['getNameList', 'changeIsRendering', 'showlist']),
    showPassword() {
      this.isShowPassword = !this.isShowPassword;
    },
    // 用户登录
    login() {
      // 校验用户名
      let userState = account.vertify_username(this.user.username)
      let changeErrorState = (type, msg) => {
        this.errorState.type = type
        this.errorState.msg = msg
      }
      if (userState.type != 2) {
        changeErrorState('error', userState.msg)
        return
      }
      // 校验密码格式
      let passwordState = account.vertify_password_for_login(this.user.password)
      if (passwordState.type != 2) {
        changeErrorState('error', passwordState.msg)
        return
      }
      // 校验图片验证码格式
      let imgState = captcha.verity_code(this.user.imgcode)
      if (imgState.type != 2) {
        changeErrorState('error', imgState.msg)
        return
      }
      // 登录
      (async () => {
        let isLogin = await account.login_verity(this.user)
        if (isLogin.isok) {
          this.getData()
          // this.$router.push('Home')
          // this.$Message.success('用户登录成功');
          let message = '用户登录成功';
          // 校验密码格式, 高强度要求
          let passwordState = account.vertify_password(this.user.password);
          console.log(passwordState);
          if (passwordState.type == 1) {
            message = '用户登录成功,但您的密码强度较弱,建议更改密码';
          }
          this.$message({
            message,
            type: 'success'
          });

        } else {
          if (isLogin.status == 400) {
            this.user.password = ''
          }
          changeErrorState('error', isLogin.msg)
          this.changeVerify()
        }
      })()
    },

    // 获取机构
    getData() {
      (async () => {
        let getState = await company.get_searchlist()
        if (getState.status) {
          let datalist = getState.data
          let namalist = []

          // console.log(datalist, 8888)

          if (datalist.length >= 1) {
            for (let i = 0; i < datalist.length; i++) {
              namalist.push({
                value: datalist[i].name,
                id: datalist[i].id,
                type: datalist[i].type
              })
            }
            let currently
            let SgetState = await company.get_list()
            if (SgetState.status) {
              currently = SgetState.data.content
            } else {
              this.$message.error('机构查询接口异常，请稍候重试')
            }
            for (let i = 0; i < currently.length; i++) {
              if (currently[i].id == namalist[0].id) {
                sessionStorage.currently = JSON.stringify(currently[i])
              }
            }
            sessionStorage.itemName = JSON.stringify(namalist[0])
            this.changeIsRendering(namalist[0].type)

            sessionStorage.itemNamea = JSON.stringify(namalist)
            this.getNameList(JSON.stringify(namalist))
            this.$router.push('/')
            location.reload();
          } else {
            this.$router.push('Home')
            location.reload();
          }
        } else {
          this.$message.error(getState.msg)
        }
      })()
    },

    // 切换焦点
    changeFocus(num) {
      let allInput = document.getElementById('login').querySelectorAll('input')
      if (num < allInput.length && num > -1) {
        allInput[num].focus()
      }
    },
    // 监听焦点事件
    getFocus(num) {
      this.focusState = [false, false, false]
      this.focusState[num] = true
    },
    loseFocus(num) {
      this.focusState = [false, false, false]
    },
    // 切换验证码
    changeVerify() {
      this.verifyUrl = captcha.verityimg_change()
    }
  }
}
</script>
<style lang="stylus" scoped>
.maintain {
  width: 430px;
  height: 450px;
  box-sizing: border-box;
  border-radius: 5px;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.3);
  background: #fff;
  padding: 40px;
  position: relative;

  .mt-head {
    font-size: 24px;
    font-weight: bold
    color: #00ccff;
    text-align: center;
  }

  .mt-content {
    font-size: 18px;
    color: #00ccff;
    text-align: left;
  }
}

.login {
  width: 430px;
  height: 450px;
  box-sizing: border-box;
  border-radius: 5px;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.3);
  background: #fff;
  padding: 40px;
  position: relative;

  .lg-con {
    width: 100%;
    height: 100%;

    .lg-con-head {
      line-height: 40px;
      font-size: 18px;
      color: #666666;
      text-align: left;
      border-bottom: 1px solid #e5e5e5;
    }

    .lg-con-msg {
      display: block;
      height: 40px;
      width: 100%;
      line-height: 50px;
      text-align: left;
      /* border: 1px solid red; */
    }

    .lg-input {
      width: 100%;
      height: 40px;
      border: 1px solid #c1c1c1;
      margin-bottom: 20px;
      border-radius: 5px;
      box-sizing: border-box;
      position: relative;
      padding: 8px 0;
      display: inline-flex;

      label {
        width: 40px;
        height: 100%;
        text-align: center;
        border-right: 1px solid #c1c1c1;

        img {
          display: inline-block;
        }
      }

      input {
        flex: 1;
        height: 100%;
        border: none;
        box-sizing: border-box;
        padding: 0 10px;

        &:focus {
          outline: none;
        }
      }

      .eye {
        cursor: pointer;
        width 25px;
        margin-left: 5px;
      }
    }

    .active {
      outline: none;
      box-shadow: 0 0 5px rgba(85, 190, 234, 1);
      border: 1px solid #55beec;
    }

    .lg-verify {
      width: 100%;
      height: 40px;
      text-align: left;
      position: relative;
      margin-bottom: 30px;

      input {
        width: 120px;
        height: 40px;
        border: 1px solid #c1c1c1;
        border-radius: 5px;
        padding: 0 10px;
        box-sizing: border-box;
        position: absolute;
        top: 0;

        &:focus {
          outline: none;
          box-shadow: 0 0 5px rgba(85, 190, 234, 1);
          border: 1px solid #55beec;
        }
      }

      .lg-verify-img {
        width: 120px;
        height: 40px;
        display: inline-block;
        position: absolute;
        overflow: hidden;
        top: 0;
        left: 130px;
        border-radius: 5px;
        border: 1px solid #c1c1c1;
        box-sizing: border-box;
        cursor: pointer;
      }

      .lg-verify-txt {
        width: 120px;
        height: 40px;
        position: absolute;
        display: inline-block;
        top: 0;
        left: 220px;
        font-size: 14px;
        line-height: 40px;
        cursor: pointer;

        &:hover {
          color: #2ea9df;
        }
      }
    }

    button {
      width: 100%;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: #2db7f5;
      border-radius: 5px;
      font-size: 16px;
      transition: all .3s ease-in-out;
      border: none;
      color: #fff;
      cursor: pointer;

      &:focus {
        outline: none;
      }

      &:hover {
        background: #57c5f7;
      }
    }

    .lg-forget {
      line-height: 40px;
      font-size: 14px;
      color: #999999;
      text-align: right;

      a {
        text-decoration: none;
        color: #999999;

        &:hover {
          color: #2ea9df;
        }
      }

      span {
        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  input:focus .lg-input {
    color: red;
  }
}

input::-ms-clear {
  display: none;
}

input::-ms-reveal {
  display: none;
}
</style>



// WEBPACK FOOTER //
// Login.vue?539aa2d0